/**
 * When the sticky header condenses (components/site/v3/ChromeCondense.client.tsx).
 * Two thresholds, so a reader resting near one does not make the bar flicker.
 */
export const CHROME_CONDENSE_AT = 96
export const CHROME_EXPAND_AT = 32

export function chromeCondensedNext(condensed: boolean, scrollY: number): boolean {
  const y = Number.isFinite(scrollY) ? scrollY : 0
  if (condensed) return y > CHROME_EXPAND_AT
  return y > CHROME_CONDENSE_AT
}
